import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { useMediaQuery, Button, } from "@mui/material";
import tokenManager from "../services/tokenManager";
import SvgPaw from "./SVG/svgPaw";

const LOGGED_OUT_FLAG = "logged_out";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showTranslationModal, setshowTranslationModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('zh');
  const [hoveredLangIndex, setHoveredLangIndex] = useState(null);
  const LANG_ITEM_HEIGHT = 36;
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setUser(true);
    } else {
      setUser(false);
    }
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  const getUserId = () => {
    const id = Cookies.get("id");
    return id;
  };

  const getUserRole = () => {
    const role = Cookies.get("role");
    return role;
  };

  const buttonStyle = {
    width: "100%",
    color: "#31BACD",
    backgroundImage: 'url("/images/wood-texture.png")',
    cursor: "pointer",
  };

  // Fetch user role
  useEffect(() => {
    const token = Cookies.get("token");
    const role = getUserRole();
    if (role === 'admin' && token) {
      setAdmin(true);
    } else {
      setAdmin(false);
    }
  }, []);

  // Sync selectedLanguage with i18n language
  useEffect(() => {
    const currentLanguage = i18n.language;
    setSelectedLanguage(currentLanguage);
  }, []);

  const handleLogout = () => {
    // Clear tokens from memory (primary storage)
    tokenManager.clear();
    localStorage.setItem(LOGGED_OUT_FLAG, "true");

    // Clear cookies (backward compatibility)
    Cookies.remove("token");
    Cookies.remove("id");
    Cookies.remove("userRole");
    Cookies.remove("refreshToken");
    Cookies.remove("refreshToken", { path: "/" });
    Cookies.remove("refreshToken", { path: "/auth/tokens/refresh" });
    Cookies.remove("refreshToken", { path: "/development/auth/tokens/refresh" });
    Cookies.remove("notifications");
    Cookies.remove("role");

    // Update UI state
    setUser(false);
    setShowLogoutModal(false);

    // Redirect to login
    navigate("/");
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <header
      className="bg-white border-b border-gray-200 py-3 md:py-0 fixed top-0 left-0 right-0 z-50 shadow-sm"
    >
      <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', padding: isMobile ? '0 16px' : '0 80px', }}>
        <Link to="/" className="text-2xl md:text-3xl font-bold ">
          <img src="/icons/ppclogo.png" alt="Logo" className="h-6 md:h-8" />
        </Link>

        <div className="flex gap-1 relative md:p-3 p-0 my-1">
          {!user && (
            <div
              className="p-2 flex items-center justify-center gap-1"
              
            >
              <img src="/icons/HotelPortal.svg" alt="Logo" className="h-5 w-5 md:h-7 md:w-7" />
              <div>{t("HotelPortal")}</div>
            </div>
          )}
          <div className="relative">
            <button
              type="button"
              className="p-2 hover:bg-gray-100 rounded-md transition-colors duration-200 cursor-pointer flex items-center justify-center gap-1"
              onClick={() => setshowTranslationModal(prev => !prev)}
              aria-expanded={showTranslationModal}
              aria-controls="languageMenu"
            ><img src="/icons/globe.svg" alt="Logo" className="h-5 w-5" />
            </button>

            {showTranslationModal && (
              <div id="languageMenu"
                onMouseLeave={() => setHoveredLangIndex(null)}
                style={{ position: "absolute", minWidth: 50, top: "calc(100% + 20px)", right: 0, backgroundColor: "#000000", border: "1px solid #D1D1D1", borderRadius: 5, display: 'flex', flexDirection: 'column', zIndex: 100 }}>
                {/* Sliding hover indicator */}
                <div style={{
                  position: "absolute",
                  top: hoveredLangIndex !== null ? hoveredLangIndex * LANG_ITEM_HEIGHT : 0,
                  left: 0,
                  right: 0,
                  height: LANG_ITEM_HEIGHT,
                  backgroundColor: "#FFF",
                  borderRadius: "6px",
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                  border: '1px solid black',
                  opacity: hoveredLangIndex !== null ? 1 : 0,
                  transition: "top 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease",
                  pointerEvents: "none",
                  zIndex: 0,
                }} />
                <Button
                  onMouseEnter={() => setHoveredLangIndex(0)}
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    height: `${LANG_ITEM_HEIGHT}px`,
                    cursor: 'pointer',
                    color: '#31BACD',
                    fontWeight: 400,
                    minWidth: 0,
                    border: '1px solid transparent',
                    borderRadius: '6px',
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); setSelectedLanguage('zh'); i18n.changeLanguage('zh'); setshowTranslationModal(false);
                  }}>
                  <div style={{ paddingRight: '2px' }}>ZH</div>
                  {selectedLanguage === 'zh' && <SvgPaw className="language-paw" />}
                </Button>
                <Button
                  onMouseEnter={() => setHoveredLangIndex(1)}
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    height: `${LANG_ITEM_HEIGHT}px`,
                    cursor: 'pointer',
                    color: '#31BACD',
                    fontWeight: 400,
                    minWidth: 0,
                    border: '1px solid transparent',
                    borderRadius: '6px',
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); setSelectedLanguage('en'); i18n.changeLanguage('en'); setshowTranslationModal(false);
                  }}>
                  <div style={{ paddingRight: '2px' }}>EN</div>
                  {selectedLanguage === 'en' && <SvgPaw className="language-paw" />}
                </Button>
              </div>
            )}
          </div>
          {user && (
            <button
              className="p-2 hover:bg-gray-100 rounded-md cursor-pointer"
              onClick={() => navigate(`/account/${getUserId()}`)}
            >
              <img src="/icons/Menu.svg" alt="Logo" className="h-5 w-5" />
            </button>
          )}
          {user && (
            <button
              className="p-2 hover:bg-gray-100 rounded-md cursor-pointer"
              onClick={() => setShowLogoutModal(true)}
            >
              <img src="/icons/logOut.svg" alt="Logo" className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>

      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-xs w-full flex flex-col items-center">
            <div className="text-lg font-semibold mb-6">{t("logout")}</div>
            <div className="flex w-full gap-4">
              <button
                className="flex-1 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold"
                onClick={() => setShowLogoutModal(false)}
              >
                {t("cancel")}
              </button>
              <button
                style={buttonStyle}
                className="flex-1 py-2 rounded hover:opacity-80 font-bold"
                onClick={handleLogout}
              >
                {t("logoutConfirm")}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
